'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Box from '../../../box'
import { CheckMarkWhiteIcon } from '../../../icons'
import LinearGradient from '../../../linear-gradient'

/* -----------------------------------------------------------------------------
 * CheckBoxField
 * -------------------------------------------------------------------------- */

const MARK_SCALE = 0.6

export type CheckboxWrapperProps = {
  children: React.ReactNode
  isChecked: boolean
  size?: number
}

export default function CheckBoxWrapper({
  children,
  isChecked,
  size = 20,
  ...rest
}: CheckboxWrapperProps) {
  const Wrapper = isChecked ? LinearGradient : Box

  return (
    <Wrapper
      borderRadius='small'
      borderWidth={isChecked ? 0 : 1}
      borderColor='shade05'
      height={size}
      width={size}
      {...rest}
    >
      {isChecked && (
        <Box
          position='absolute'
          justifyContent='center'
          alignItems='center'
          width='100%'
          height='100%'
        >
          <CheckMarkWhiteIcon
            height={size * MARK_SCALE}
            width={size * MARK_SCALE}
          />
        </Box>
      )}
      {children}
    </Wrapper>
  )
}
